import script from "./RecoveryGoalBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryGoalBlock.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryGoalBlock.vue?vue&type=style&index=0&id=0a506756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a506756"]])

export default __exports__